import { combineReducers } from 'redux';

import { initialState } from 'modules/global/reducers/generic.page';
import createSearchReducers from 'modules/global/reducers/simpleSearchReducer';
import * as types from 'modules/questionModels/actionTypes';
import { LOCATION_CHANGE } from 'modules/router/actionTypes';
import { FETCH_MODEL_SUCCESS } from 'modules/selfServices/actionTypes';
import { uniq } from 'utils/ObjectUtils';

import dashboard from './dashboard';
import details from './details';

/**
 * @typedef {{
 *   details: import('./details').QuestionModelsUIDetailsReducer,
 *   dashboard: import('./dashboard').QuestionModelsUIDashboardReducer,
 *   configSelect: import('modules/global/reducers/simpleSearchReducer').SimpleSearchReducer,
 *   select: import('modules/global/reducers/simpleSearchReducer').SimpleSearchReducer,
 * }} QuestionModelUIReducer
 */

const updateFromModel = (state, { payload: model }) =>
  uniq([...state, ...(model.questionFormModel?.id ? [model.questionFormModel.id] : [])]);

export default combineReducers({
  details,
  dashboard,
  configSelect: createSearchReducers(types.FETCH_QUESTION_MODELS, {
    global: { matcher: ({ meta }) => meta.source === 'config' },
  }),
  select: createSearchReducers(types.FETCH_QUESTION_MODELS, {
    ids: {
      [FETCH_MODEL_SUCCESS]: updateFromModel,
    },
    page: {
      [LOCATION_CHANGE]: () => initialState,
    },
    global: {
      matcher: ({ meta }) => meta.source === 'questions-select',
    },
  }),
});
